import { DetailView, findEntityBySlug } from '@/modules/propfirms/components/detail-view';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/propfirms/$slug')({
  beforeLoad: ({ params }) => {
    if (!findEntityBySlug(params.slug)) {
      throw redirect({ to: '/dashboard/propfirms' });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  return <DetailView slug={slug} />;
}
